<template>
  <div class="login" :style="'background-image: url(' + bgImg + ');'">
    <div>
      <div class="login_title_all">
        <div class="login_title">供应链协同平台</div>
        <div class="login_span">Supply Chain Collaboration Platform</div>
      </div>
      <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="dataRule"
        @keyup.enter.native="login()"
        class="login-form"
      >
        <div class="item_title">
          <span v-if="loginType == 0" class="item_title_font">供应商</span>
          <span v-else class="item_title_font">委外商</span>
          <i
            style="transform: rotate(90deg); font-size: 16px; cursor: pointer"
            class="el-icon-sort"
            @click="loginTypeClick()"
          ></i>
        </div>
        <el-form-item prop="tenantCode">
          <div class="input">
            <div style="font-size: 30px; padding: 12px 10px 0px 15px">
              <img style="width: 30px; height: 30px" :src="encodingImg" />
            </div>
            <input
              v-model="dataForm.tenantCode"
              class="inputTwo"
              placeholder="公司编码"
            />
          </div>
        </el-form-item>
        <el-form-item prop="mobilePhone">
          <div class="input">
            <div style="font-size: 30px; padding: 12px 10px 0px 15px">
              <img style="width: 30px; height: 30px" :src="userImg" />
            </div>

            <input
              v-model="dataForm.mobilePhone"
              class="inputTwo"
              placeholder="请输入账号"
            />
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <div class="input">
            <div style="font-size: 30px; padding: 12px 10px 0px 15px">
              <img style="width: 30px; height: 30px" :src="passImg" />
            </div>
            <input
              v-model="dataForm.password"
              type="password"
              class="inputTwo"
              placeholder="请输入密码"
            />
          </div>
        </el-form-item>
        <div class="login_check">
          <el-checkbox v-model="checked">记住密码</el-checkbox>
        </div>
        <el-form-item style="width: 100%">
          <div @click="login()" class="btn">
            <span v-if="!loading">登 录 账 号</span>
            <span v-else>登 录 中...</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div style="clear: both"></div>
    <!--  底部  -->
    <div class="el-login-footer">
      <span style="margin-left: 156px"
        >Copyright © 2025-2031 qingguang.erp All Rights Reserved.</span
      >
    </div>
  </div>
</template>

<script>
import { SystemController } from "@/api";
import { mapMutations } from "vuex";
import projectConfig from "@/core/config";
import { encrypt, setToken, setUserInfo } from "@/utils";
import Verify from "@/components/Verifition/Verify.vue";
import {
  getSysTenantByTenantCode,
  getLoginInfo,
} from "@/api/myController/SysGlobalDictController";
// import {} from "@/utils/myUtils";
export default {
  components: {
    Verify,
  },
  data() {
    return {
      loginType: 0,
      // -------------------------------------
      checked: true,
      loading: false,
      encodingImg: require("@/assets/icons/encoding.png"),
      userImg: require("@/assets/icons/user.png"),
      passImg: require("@/assets/icons/cipher.png"),
      bgImg: require("@/assets/images/bgV3.jpg"),
      bkImg: require("@/assets/img/login.png"),
      logoImg: require("@/assets/img/login_logo.png"),
      bgKImg: require("@/assets/images/bgkV2.png"),
      dataForm: {
        tenantCode: "",
        mobilePhone: "",
        password: "",
      },
      orderParam: {
        asc: false,
        dateAggregateBy: "",
        fieldName: "createTime",
      },
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
      },
      dataRule: {
        tenantCode: [{ required: true, message: "租户编码不能为空", trigger: "blur" }],
        mobilePhone: [{ required: true, message: "帐号不能为空", trigger: "blur" }],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }],
      },
      projectName: projectConfig.projectName,
    };
  },
  created() {
    if (localStorage.getItem("loginType")) {
      this.loginType = localStorage.getItem("loginType");
    }
    if (localStorage.getItem("teamAccountData")) {
      let json = JSON.parse(localStorage.getItem("teamAccountData"));
      this.dataForm.tenantCode = json.tenantCode;
      this.dataForm.mobilePhone = json.loginName;
      this.dataForm.password = json.password;
    }
  },
  methods: {
    loginTypeClick() {
      if (this.loginType == 1) {
        this.loginType = 0;
      } else {
        this.loginType = 1;
      }
    },
    // 获取当前消息的条数
    getList() {
      this.list = [];
    },
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.$refs.verify.show();
        }
      });
    },
    // 默认缓存值
    mainValue() {
      // 清除全局变量的缓存
      this.$root.route_path = ""; // 自定义全局变量
      this.$root.route_all_path = []; // 所有路由
      this.$root.home_radio = ""; // 页面布局
      this.$root.menuId = null;
      this.$root.menuList = [];
      // 默认良品仓库
      this.$root.warehouseId = null;
      this.$root.warehouseName = null;
      // 不良品仓库
      this.$root.unWarehouseId = null;
      this.$root.unWarehouseName = null;
      // 自定义字段
      this.$root.sysEntityExt_1 = []; // 产品
      this.$root.sysEntityExt_6 = []; // 客户
      this.$root.sysEntityExt_8 = []; // 工序
      this.$root.sysEntityExt_11 = []; // 供应商
      this.$root.sysEntityExt_131 = []; // 生产单
      this.$root.sysEntityExt_132 = []; // 设计中心
      this.$root.sysEntityExt_136 = []; // BOM主表
      this.$root.sysEntityExt_137 = []; // BOM物料
      this.$root.sysEntityExt_138 = []; // BOM工序
      this.$root.sysEntityExt_601 = []; // 客户跟进记录
      this.$root.sysEntityExt_101 = []; // 销售订单主表
      this.$root.sysEntityExt_102 = []; // 销售订单子表
      this.$root.sysEntityExt_103 = []; // 销售出库订单主表
      this.$root.sysEntityExt_104 = []; // 销售出库订单子表
      this.$root.sysEntityExt_105 = []; // 销售对账
      this.$root.sysEntityExt_121 = []; // 采购订单主表
      this.$root.sysEntityExt_122 = []; // 采购订单子表
      this.$root.sysEntityExt_123 = []; // 采购入库订单主表
      this.$root.sysEntityExt_124 = []; // 采购入库订单子表
      this.$root.sysEntityExt_125 = []; // 采购对账
      this.$root.sysEntityExt_151 = []; // 样品单主表
      this.$root.sysEntityExt_152 = []; // 样品单子主表
      this.$root.sysEntityExt_141 = []; // 报价单主表
      this.$root.sysEntityExt_142 = []; // 报价单子主表
      this.$root.sysEntityExt_153 = []; // 日报
      this.$root.sysEntityExt_183 = []; // 项目管理
      this.$root.sysEntityExt_185 = []; // 收支明细
      this.$root.sysEntityExt_1317 = []; // 生产单工序
      this.$root.sysEntityExt_1301 = []; // 领料单子表
      this.$root.sysEntityExt_1304 = []; // 报工单
      this.$root.sysEntityExt_1305 = []; // 完工单
      this.$root.color = "#1476c3"; // 与主体主色保持一致
      this.$root.accuracy = 4; // 价格精度
      this.$root.numberAccuracy = 2; // 数量精度
      this.$root.bomIsShowPrice = 1; // 1价格啥的都显示，2不显示价格
      this.$root.repeatDataTimeData = {}; // 防止接口重复提交
      this.$root.messageCount = 0; // 未读消息数量
      this.$root.userList = []; // 员工缓存
      this.$root.bomMaterialsCount = 20; // BOM所需物料数量
      this.$root.listQueryPageSize = 20; // 默认每页显示的数量
      this.$root.homeIndex = 0; // 判断页面什么时候刷新
      this.$root.examineList = []; // 审核配置列表
      this.$root.homeMode = "0"; // 0.标准模式，1.演示模式
      this.$root.menuCacheData = {}; // 系统配置缓存
      this.$root.defaultValueList = []; // 默认值配置
      this.$root.langValue = "cn"; //默认语音配置
      this.$root.tenantData = {}; //默认系统配置
      this.$root.fnaCurrencyList = []; //币种
    },
    login(verifyParams) {
      this.loading = true;
      // getLoginInfo().then(res=>{

      // })
      this.mainValue();
      let params = {
        tenantCode: this.dataForm.tenantCode,
        loginName: this.dataForm.mobilePhone,
        password: encrypt(this.dataForm.password),
        captchaVerification: "10086",
        sysType: this.loginType,
        // captchaVerification: (verifyParams || {}).captchaVerification,
      };
      setToken(null);
      // ----------------------------------测试数据
      let menuList = [
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "供应商",
          updateTime: "2024-04-08 10:46:10",
          parentId: 0,
          createTime: "2024-04-08 10:46:10",
          tenantAvailable: true,
          tenantId: "1787739282539036676",
          menuId: "1",
          reportPageId: 0,
          menuType: 0,
          showOrder: 1,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "采购报价",
          updateTime: "2024-04-08 10:46:10",
          parentId: 0,
          createTime: "2024-04-08 10:46:10",
          tenantAvailable: true,
          tenantId: "1787739282539036676",
          menuId: "2",
          reportPageId: 0,
          menuType: 0,
          showOrder: 1,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "采购过程",
          updateTime: "2024-04-08 10:46:10",
          parentId: 0,
          createTime: "2024-04-08 10:46:10",
          tenantAvailable: true,
          tenantId: "1787739282539036676",
          menuId: "3",
          reportPageId: 0,
          menuType: 0,
          showOrder: 1,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "采购对账",
          updateTime: "2024-04-08 10:46:10",
          parentId: 0,
          createTime: "2024-04-08 10:46:10",
          tenantAvailable: true,
          tenantId: "1787739282539036676",
          menuId: "4",
          reportPageId: 0,
          menuType: 0,
          showOrder: 1,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "purchase_order",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "基本资料",
          updateTime: "2024-04-08 10:54:09",
          createTime: "2024-04-08 10:54:09",
          tenantAvailable: true,
          parentId: "1",
          menuId: "11",
          reportPageId: 0,
          menuType: 1,
          showOrder: 1002,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "purchase_order",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "资质认证",
          updateTime: "2024-04-08 10:54:09",
          createTime: "2024-04-08 10:54:09",
          tenantAvailable: true,
          parentId: "1",
          menuId: "12",
          reportPageId: 0,
          menuType: 1,
          showOrder: 1002,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "purchase_order",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "基本合同",
          updateTime: "2024-04-08 10:54:09",
          createTime: "2024-04-08 10:54:09",
          tenantAvailable: true,
          parentId: "1",
          menuId: "13",
          reportPageId: 0,
          menuType: 1,
          showOrder: 1002,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "purchase_order",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "询价单",
          updateTime: "2024-04-08 10:54:09",
          createTime: "2024-04-08 10:54:09",
          tenantAvailable: true,
          parentId: "2",
          menuId: "21",
          reportPageId: 0,
          menuType: 1,
          showOrder: 1002,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "purchase_order",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "采购订单",
          updateTime: "2024-04-08 10:54:09",
          createTime: "2024-04-08 10:54:09",
          tenantAvailable: true,
          parentId: "3",
          menuId: "31",
          reportPageId: 0,
          menuType: 1,
          showOrder: 1002,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "purchase_storage",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "交期回复",
          updateTime: "2024-04-08 10:54:09",
          createTime: "2024-04-08 10:54:09",
          tenantAvailable: true,
          parentId: "3",
          menuId: "32",
          reportPageId: 0,
          menuType: 1,
          showOrder: 1003,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "purchase_storage",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "采购发货",
          updateTime: "2024-04-08 10:54:09",
          createTime: "2024-04-08 10:54:09",
          tenantAvailable: true,
          parentId: "3",
          menuId: "33",
          reportPageId: 0,
          menuType: 1,
          showOrder: 1003,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "purchase_return",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "采购退货",
          updateTime: "2024-04-08 10:54:09",
          createTime: "2024-04-08 10:54:09",
          tenantAvailable: true,
          parentId: "3",
          menuId: "34",
          reportPageId: 0,
          menuType: 1,
          showOrder: 1003,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "reconciliation_bill",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "对账单",
          updateTime: "2024-04-08 10:54:09",
          createTime: "2024-04-08 10:54:09",
          tenantAvailable: true,
          parentId: "4",
          menuId: "41",
          reportPageId: 0,
          menuType: 1,
          showOrder: 1003,
          onlineMenuPermType: 0,
        },
        {
          createDeptId: "1657750402902265863",
          createUserId: "1657750402893877248",
          formRouterName: "reconciliation_unBill",
          updateUserId: "1657750402893877248",
          onlineFormId: 0,
          icon: "",
          menuName: "未对账",
          updateTime: "2024-04-08 10:54:09",
          createTime: "2024-04-08 10:54:09",
          tenantAvailable: true,
          parentId: "4",
          menuId: "42",
          reportPageId: 0,
          menuType: 1,
          showOrder: 1004,
          onlineMenuPermType: 0,
        },
      ];

      SystemController.doCooperativeSupplierLogin(this, params, null, {
        showMask: false,
      })
        .then((data) => {
          // 记住登录类型
          localStorage.setItem("loginType", this.loginType);
          // 记住密码
          if (this.checked) {
            localStorage.setItem(
              "teamAccountData",
              JSON.stringify({
                tenantCode: this.dataForm.tenantCode,
                loginName: this.dataForm.mobilePhone,
                password: this.dataForm.password,
              })
            );
          } else {
            localStorage.removeItem("teamAccountData");
          }
          // let userData = {
          //   gshowName: "协同供应商",
          //   showName: "管理员",
          // };
          // this.setMenuList(menuList);
          // setToken(data.data.tokenData);
          // this.setUserInfo(data.data);
          // this.setCurrentMenuId(null);
          // this.$router.replace({ name: "main" });
          // data.data.menuList.forEach((item) => {
          //   item.menuId = item.cooperativeSupplierMenuId;
          //   item.menuName = item.cooperativeSupplierMenuName;
          //   item.menuType = item.cooperativeSupplierMenuType;
          // });
          this.setMenuList(data.data.menuList);
          delete data.data.menuList;
          setToken(data.data.tokenData);
          this.setUserInfo(data.data);
          this.setCurrentMenuId(null);
          this.$router.replace({ name: "main" });
          //
        })
        .catch((e) => {
          this.loading = false;
        });
      return;
      SystemController.doCooperativeSupplierLogin(this, params, null, {
        showMask: false,
      })
        .then((data) => {
          // 记住密码
          if (this.checked) {
            localStorage.setItem(
              "teamAccountData",
              JSON.stringify({
                loginName: this.dataForm.mobilePhone,
                password: this.dataForm.password,
              })
            );
          } else {
            localStorage.removeItem("teamAccountData");
          }
          this.setMenuList(data.data.menuList);
          delete data.data.menuList;
          setToken(data.data.tokenData);
          this.setCurrentMenuId(null);
          this.$router.replace({ name: "main" });
          //
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    onVerifySuccess(verifyParams) {
      this.login(verifyParams);
    },
    ...mapMutations(["setUserInfo", "setMenuList", "setCurrentMenuId"]),
  },
  mounted() {
    this.setMenuList([]);
    this.setUserInfo({});
    setToken();
  },
};
</script>

<style lang="scss" scoped>
.login {
  padding-right: 187px;
  display: flex;
  justify-content: right;
  align-items: center;
  height: 100vh;
  background-size: cover;
  position: relative;
}

.login-form {
  width: 517px;
  height: 559px;
  border-radius: 4px;
  background-size: 100% 100%;
  padding: 90px 25px 5px 25px;
  background-color: #fff;
  .el-input {
    height: 38px;
    input {
      height: 38px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 38px;
  margin-left: 20px;
  float: left;
  img {
    width: 172px;
    height: 64px;
    opacity: 1;
    cursor: pointer;
    vertical-align: middle;
  }
}
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #000;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
.login-code-img {
  height: 38px;
}
.input {
  width: 425px;
  height: 58px;
  opacity: 1;
  border: 2px solid #1476c3;
  margin: 0px auto;
  margin-bottom: 10px;
  display: flex;
  // border-top-left-radius: 20px;
}
.inputTwo {
  text-align: left;
  width: calc(100% - 60px);
  height: 58px;
  padding-left: 5px;
  padding-right: 5px;
  outline: none;
  background: transparent;
  border: none;
  outline: medium;
  font-size: 18px;
}

::-webkit-input-placeholder {
  /* WebKit browsers，webkit内核浏览器 */
  color: #1476c3;
  font-size: 16px;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #1476c3;
  font-size: 16px;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #1476c3;
  font-size: 16px;
}
:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #1476c3;
  font-size: 16px;
}
::v-deep .el-form-item__content {
  text-align: center;
}
.btn {
  width: 425px;
  height: 59px;
  line-height: 59px;
  margin: 0 auto;
  opacity: 1;
  background-color: #1476c3;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #fff;
  text-align: center;
  vertical-align: top;
  cursor: pointer;
}

//修改选择框的颜色
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #1476c3 !important;
  background-color: #1476c3 !important;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #1476c3 !important;
}
//修改选中后文本的颜色
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1476c3 !important;
}
.login_check {
  width: 425px;
  margin: 0 auto;
  margin-top: -7px;
  margin-bottom: 40px;
}
.login_title_all {
  text-align: center;
  margin-bottom: 50px;
}
.login_title {
  font-family: Adobe Heiti Std;
  font-size: 52px;
  color: #fffffe;
}
.login_span {
  font-family: Adobe Heiti Std;
  font-size: 20px;
  color: #fffffe;
}
.item_title {
  text-align: center;
  margin-bottom: 20px;
  margin-top: -40px;
}
.item_title_font {
  font-size: 26px;
  margin-right: 4px;
  font-weight: bold;
}
</style>
